import axios from '@/libs/axios'

export default {
    getAuthUser: ({state, getters, commit}) => {
		
		return  new Promise(async (resolve, reject) => {
			let token = [
				{
					type: 'token',
					value: getters.getToken
				}
			]
			commit('setToken', token)
			await axios.get('user/id/my/set/first')
			.then(res => {
				localStorage.setItem('role',res.data.data.records.roles)
				resolve(res.data)
			})
			.catch(err => reject(err))
		})

    },
    logOutAuthUser: ({state, getters, commit}) => {
			// return axios.delete('/logout')
			// 	.then(() => {
			// 		console.log("ini commit", commit)
			// 		// commit('removeToken')
			// 		// commit('removeCookies')
			// 	})
			// 	.catch(() => {
			// 		throw new Error('Error Logout & Deleting Token')
			// 	})
    },
}